export default "__VITE_PUBLIC_ASSET__a5d8d1d1__"